import { array, bool, func, number, object } from 'prop-types'
import { isValidElement, memo, useMemo } from 'react'

const BodyRow = memo(
   ({
      data,
      header,
      index = 0,
      isLastSticky = false,
      isSticky = false,
      onClickRow,
      rowIndex = 0,
      stickyLeft = 0,
      withPadding = true,
   }) => {
      const isClickable = useMemo(() => {
         const isFunction = typeof onClickRow === 'function'
         const clickable =
            typeof header?.isClickable === 'boolean'
               ? header?.isClickable
               : true
         return isFunction && clickable
      }, [onClickRow, header?.isClickable])

      const className = useMemo(() => (isClickable ? 'cursor-pointer' : ''), [isClickable])

      const memoizedContent = useMemo(() => {
         const getContent = header?.getContent
         const key = header?.key
         const value = data?.[key]
         const hasGetContent = typeof getContent === 'function'
         const content = hasGetContent
            ? getContent({ data, key, index: rowIndex })
            : value
         return content ? content : '-'
      }, [data, header, rowIndex])

      const isElementContent = isValidElement(memoizedContent)
      const titleAttr = useMemo(
         () => (typeof memoizedContent === 'string' ? memoizedContent : undefined),
         [memoizedContent],
      )

      return (
         <td
            className={className}
            data-padding={withPadding}
            data-fill={isElementContent}
            data-sticky={isSticky}
            data-sticky-last={isLastSticky}
            style={isSticky ? { left: stickyLeft } : undefined}
            title={titleAttr}
            onClick={event => {
               if (isClickable) {
                  onClickRow({
                     columnIndex: index,
                     data,
                     event,
                     rowIndex,
                  })
               }
            }}
         >
            <div className={isElementContent ? 'cell-fill' : 'cell-content'}>
               {memoizedContent}
            </div>
         </td>
      )
   },
)

BodyRow.propTypes = {
   data: array,
   header: object,
   index: number,
   isLastSticky: bool,
   isSticky: bool,
   onClickRow: func,
   rowIndex: number,
   stickyLeft: number,
   withPadding: bool,
}

export default BodyRow